export const capitalizeFirstLetter = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

const extractErrorMessage = (error) => {
  if (!error) return "Unknown error"

  const possibleMessages = [
    error?.reason,
    error?.shortMessage,
    error?.message,
    error?.data?.message,
    error?.error?.message,
    error?.error?.data?.message,
    error?.info?.error?.message,
    error?.cause?.message,
  ]

  const message = possibleMessages.find(
    (item) => typeof item === "string" && item.trim().length > 0,
  )

  return message || "Unknown error"
}

const cleanErrorMessage = (message) => {
  if (!message) return "Transaction failed"

  let normalizedMessage = message

  if (normalizedMessage.includes("execution reverted:")) {
    normalizedMessage = normalizedMessage.split("execution reverted:")[1].trim()
  }

  if (normalizedMessage.includes("MetaMask Tx Signature:")) {
    normalizedMessage = normalizedMessage
      .replace("MetaMask Tx Signature:", "")
      .trim()
  }

  return normalizedMessage
}

export function formatMetamaskError(error) {
  if (!window.ethereum) {
    return "MetaMask not found. Please install or enable MetaMask."
  }

  const code = error?.code ?? error?.error?.code ?? error?.data?.code
  const rawMessage = extractErrorMessage(error)
  const message = cleanErrorMessage(rawMessage)
  const lowerMessage = message.toLowerCase()

  if (code === 4001) {
    return "Transaction was rejected in MetaMask."
  }

  if (code === 4100) {
    return "Access to the wallet was not granted."
  }

  if (code === 4200) {
    return "This operation is not supported by your wallet."
  }

  if (code === 4900) {
    return "Wallet is disconnected."
  }

  if (code === 4901) {
    return "Wallet is connected to a different network."
  }

  if (code === -32000) {
    if (lowerMessage.includes("insufficient funds")) {
      return "Insufficient funds to pay for gas or transaction value."
    }

    if (lowerMessage.includes("nonce")) {
      return "Invalid transaction nonce. Please try again."
    }
  }

  if (lowerMessage.includes("user rejected")) {
    return "Transaction was rejected in MetaMask."
  }

  if (lowerMessage.includes("insufficient funds")) {
    return "Insufficient funds to pay for gas or transaction value."
  }

  if (lowerMessage.includes("execution reverted")) {
    return cleanErrorMessage(message)
  }

  if (lowerMessage.includes("replacement transaction underpriced")) {
    return "Replacement transaction underpriced. Try again in a few seconds."
  }

  if (lowerMessage.includes("nonce too low")) {
    return "Nonce is too low. Please retry the transaction."
  }

  if (
    lowerMessage.includes("gas required exceeds allowance") ||
    error.message.includes("cannot estimate gas")
  ) {
    return "Gas estimate failed. The transaction may fail."
  }

  if (lowerMessage.includes("network changed")) {
    return "Network was changed in MetaMask. Please try again."
  }

  if (lowerMessage.includes("unsupported chain")) {
    return "Unsupported network in wallet."
  }

  if (lowerMessage.includes("could not coalesce error")) {
    return "Wallet/RPC returned an unknown error. Please try again."
  }

  if (
    lowerMessage.includes("transfer amount exceeds balance") ||
    error.message.includes("transfer amount exceeds balance")
  ) {
    return "Transfer amount exceeds balance."
  }
  return message || "Transaction failed"
}

export const formatBoxName = (boxName) => {
  return boxName.replace(/_/g, " ")
}
